import { post } from './common';
import { Dispatch } from 'redux';

export const FETCH_SUPERSET_TOKEN_REQUEST = 'FETCH_SUPERSET_TOKEN_REQUEST';
export const FETCH_SUPERSET_TOKEN_SUCCESS = 'FETCH_SUPERSET_TOKEN_SUCCESS';
export const FETCH_SUPERSET_TOKEN_FAILURE = 'FETCH_SUPERSET_TOKEN_FAILURE';

export const SET_MONITOR_QUERY_DATA = 'SET_MONITOR_QUERY_DATA';

export const fetchSupersetToken = (dashboardId: string) => async (dispatch: Dispatch) => {
  dispatch({ type: FETCH_SUPERSET_TOKEN_REQUEST });

  try {
    const response = await post('/monitor/generate/superset-auth-token', { dashboardId });

    if (response.error) {
      dispatch({
        type: FETCH_SUPERSET_TOKEN_FAILURE,
        payload: response.error
      });
    } else {
      dispatch({
        type: FETCH_SUPERSET_TOKEN_SUCCESS,
        payload: response
      });
      return response;
    }
  } catch (error: any) {
    dispatch({
      type: FETCH_SUPERSET_TOKEN_FAILURE,
      payload: error.message || 'Failed to fetch Superset token'
    });
  }
};

export const setMonitorQueryData = (payload: any) => {
  return {
    type: SET_MONITOR_QUERY_DATA,
    payload,
  };
}; 